import { render } from "./DevInfoBlock.vue?vue&type=template&id=33e0fccc&scoped=true"
import script from "./DevInfoBlock.vue?vue&type=script&lang=js"
export * from "./DevInfoBlock.vue?vue&type=script&lang=js"

import "./DevInfoBlock.vue?vue&type=style&index=0&id=33e0fccc&scoped=true&lang=css"

import exportComponent from "C:\\Develop\\web\\notigo_base\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e0fccc"]])

export default __exports__